import * as tslib_1 from "tslib";
import React from 'react';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import s from './Who.scss';
var UserList = /** @class */ (function (_super) {
    tslib_1.__extends(UserList, _super);
    function UserList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserList.prototype.render = function () {
        var _this = this;
        var users = this.props.users;
        return (React.createElement("ul", { className: s['user-list'] }, users.map(function (user) { return (React.createElement("li", { className: s['user'], key: user.userId }, _this.renderUserLinkWithAvatar(user))); })));
    };
    UserList.prototype.renderUserLinkWithAvatar = function (user) {
        return (React.createElement(React.Fragment, null,
            React.createElement(UserAvatar, { user: user, className: s['user-avatar'] }),
            React.createElement(UserLink, { user: user, className: s['username'] })));
    };
    return UserList;
}(React.Component));
export { UserList };
export default UserList;
//# sourceMappingURL=UserList.js.map